export interface IAuthSlice {
    accessToken: string
    loginErr: string
    onLoginSuccess: boolean
}

export interface IJobSlice {
    allJobsEn: IJob[]
    allJobsTr: IJob[]
    currentJob: IJob | undefined
    isSendingApplication: boolean
}

export interface IJob {
    _id: string
    title: string
    firm: string
    jobType: string
    workType: "Uzaktan" | "Ofis"
    img?: string
    location: string
    sector: SectorsTr | SectorsEn
    jobDefinition: {
        text: string
        items?: string[]
    }
    jobCriteria?: ICriteria[]
    lang: "tr" | "en"
}

export interface IJobPayload {
    title: string
    firm: string
    jobType: string
    // workType: string
    location: string
    sector: string
    jobDefinition: string
    jobCriteria: string[]
    img?: string
    lang: "tr" | "en"
}

type ICriteria = {
    key: string
    value: string
}

export enum SectorsTr {
    AtikYonveGeriDon = "Atık Yön ve Geri Dön",
    Bilisim = "Bilişim",
    Danismanlik = "Danışmanlık",
    DayanikliTuketim = "Dayanıklı Tüketim",
    Denizcilik = "Denizcilik",
    Diger = "Diğer",
    Egitim = "Eğitim",
    Elektrik = "Elektrik",
    Enerji = "Enerji",
    Finans = "Finans",
    Gida = "Gıda",
    Guvenlik = "Güvenlik",
    Havacilik = "Havacılık",
    Hizmet = "Hizmet",
    HizliTuketim = "Hızlı Tüketim",
    Kimya = "Kimya",
    Maden = "Maden",
    Medya = "Medya",
    Otomotiv = "Otomotiv",
    Perakende = "Perakende",
    Saglik = "Sağlık",
    Sigortacilik = "Sigortacılık",
    Tarim = "Tarım",
    Tekstil = "Tekstil",
    Telekom = "Telekom",
    Ticaret = "Ticaret",
    Turizm = "Turizm",
    Uretim = "Üretim"
}

export enum SectorsEn {
    AtikYonveGeriDon = "Waste Management and Recycling",
    Bilisim = "Information Technology",
    Danismanlik = "Consulting",
    DayanikliTuketim = "Durable Consumer Goods",
    Denizcilik = "Maritime",
    Diger = "Other",
    Egitim = "Education",
    Elektrik = "Electricity",
    Enerji = "Energy",
    Finans = "Finance",
    Gida = "Food",
    Guvenlik = "Security",
    Havacilik = "Aviation",
    Hizmet = "Service",
    HizliTuketim = "Fast-Moving Consumer Goods",
    Kimya = "Chemistry",
    Maden = "Mining",
    Medya = "Media",
    Otomotiv = "Automotive",
    Perakende = "Retail",
    Saglik = "Healthcare",
    Sigortacilik = "Insurance",
    Tarim = "Agriculture",
    Tekstil = "Textile",
    Telekom = "Telecommunications",
    Ticaret = "Trade",
    Turizm = "Tourism",
    Uretim = "Manufacturing"

}